import { FC } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { DropDownChevronDownIcon } from 'assets/icons';

export interface RescheduleOption {
  id: string;
  label: string;
  action: () => void | Promise<void>;
}

interface RescheduleDropdownProps {
  options: RescheduleOption[];
  isDisabled?: boolean;
  className?: string;
  isLoading?: boolean;
}

const RescheduleDropdown: FC<RescheduleDropdownProps> = ({
  options,
  isDisabled = false,
  className = '',
  isLoading = false
}) => {
  return (
    <Popover className={`relative ${className}`}>
      {({ open, close }) => (
        <>
          <Popover.Button
            disabled={isDisabled || isLoading}
            className={`flex h-fit items-center gap-2 p-1 text-sbase font-semibold text-secondary ${
              isDisabled || isLoading ? 'pointer-events-none opacity-50' : 'cursor-pointer'
            }`}>
            <span>Re-schedule job</span>
            <DropDownChevronDownIcon
              className={`path-fill-current h-[8px] w-[12px] text-secondary transition-transform 
                  ${open ? 'rotate-180' : ''}`}
            />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1">
            <Popover.Panel
              className="absolute left-0 z-50 mt-1 w-56 rounded-md border border-borderGray
             bg-white shadow-lg">
              <div className="py-1">
                {options.map(option => (
                  <button
                    key={option.id}
                    onClick={async () => {
                      await option.action();
                      close();
                    }}
                    className="block w-full px-4 py-2 text-left text-sbase font-medium text-primaryText
                     hover:bg-gray-50 focus:bg-gray-50 focus:outline-none">
                    {option.label}
                  </button>
                ))}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default RescheduleDropdown;
